const updateGameStateBadge = (state = {}, action) => {
    const {
        type = null,
        datasource,
        data = {}
    } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const {
            gameData: {
                status: {
                    extendedStatus,
                    abstractGameState,
                    statusCode
                } = {}
            } = {}
        } = data;

        return {
            ...state,
            extendedStatus,
            gameStatus: {
                abstractGameState,
                statusCode
            }
        };
    }

    return state;
};

export default updateGameStateBadge;
